import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { ReplaySubject, Subject } from 'rxjs';
import { NdtEnvironment } from 'src/environments/environment.interface';
import { EnvironmentService } from 'src/environments/environment.service';

@Injectable({ providedIn: 'root' })
export class NdtHubConnectionService {
   connection: signalR.HubConnection;

   // Subscriptions to a ReplaySubject will do nothing if the subject has not been nexted
   connected: ReplaySubject<true> = new ReplaySubject<true>(1);

   disconnected: Subject<void> = new Subject<void>();

   reconnected: Subject<void> = new Subject<void>();

   onBeforeConnected$: ReplaySubject<void> = new ReplaySubject<void>();

   constructor(private environment: EnvironmentService<NdtEnvironment>) {}

   startConnection() {
      this.refreshInitialized();
      const qs = 'v=' + new Date().getTime(); // cache buster - duplicating a tab will pull the negotiate request from the disk cache
      const hubUrl = this.environment.environment.signalrBaseUrl + 'ndt?' + qs;
      this.connection = new signalR.HubConnectionBuilder()
         .withUrl(hubUrl, {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
         })
         .withAutomaticReconnect()
         .build();

      this.connection
         .start()
         .then(() => {
            this.afterConnect();
         })
         .catch((err) => {
            // eslint-disable-next-line no-console
            return console.log('Error while starting connection: ' + err);
         });

      this.onBeforeConnected$.next();

      this.connection.onreconnected(() => {
         this.afterConnect();
         this.reconnected.next();
      });

      this.connection.onclose(() => {
         return this.disconnected.next();
      });
   }

   stopConnection() {
      this.connection.stop();
      this.connected.complete();
      this.connected = new ReplaySubject<true>(1);
   }

   private refreshInitialized() {
      this.connected.complete();
      this.connected = new ReplaySubject<true>(1);
   }

   private afterConnect() {
      this.connected.next(true);
   }
}
